import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PaymentSettingsPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <Box>
        <Box sx={{ mb: { xs: 3, md: 5 } }}>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
            mb: 1
          }}>
            <Skeleton height={isMobile ? 36 : 48} width={isMobile ? 240 : 320} />
            <Skeleton height={40} width={120} style={{ borderRadius: '12px' }} />
          </Box>
          <Skeleton height={isMobile ? 20 : 28} width={isMobile ? '100%' : 480} />
        </Box>

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 150 : 180} />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <Box sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      alignItems: { xs: 'flex-start', sm: 'center' },
                      gap: 2
                    }}>
                      <Skeleton width={50} height={30} style={{ borderRadius: '16px' }} />
                      <Box sx={{ flex: 1 }}>
                        <Skeleton height={20} width={isMobile ? '100%' : 200} />
                        <Skeleton height={14} width={isMobile ? '100%' : 280} />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 200 : 280} />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <Box sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      alignItems: { xs: 'flex-start', sm: 'center' },
                      gap: 2
                    }}>
                      <Skeleton width={50} height={30} style={{ borderRadius: '16px' }} />
                      <Box sx={{ flex: 1 }}>
                        <Skeleton height={20} width={isMobile ? '100%' : 250} />
                      </Box>
                    </Box>
                    <Skeleton height={14} width={isMobile ? '100%' : 300} style={{ marginTop: '8px' }} />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                    <Skeleton height={16} width={isMobile ? '100%' : 250} style={{ marginTop: '4px' }} />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                    <Skeleton height={16} width={isMobile ? '100%' : 220} style={{ marginTop: '4px' }} />
                  </Grid>

                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                    <Skeleton height={16} width={isMobile ? '100%' : 320} style={{ marginTop: '4px' }} />
                  </Grid>

                  <Grid item xs={12}>
                    <Skeleton height={isMobile ? 140 : 180} style={{ borderRadius: '12px', marginTop: '16px' }} />
                  </Grid>

                  <Grid item xs={12}>
                    <Skeleton height={100} style={{ borderRadius: '16px' }} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box mt={{ xs: 3, md: 5 }} display="flex" justifyContent="center">
          <Skeleton height={56} width={200} style={{ borderRadius: '12px' }} />
        </Box>
      </Box>
    </SkeletonTheme>
  );
};

export default PaymentSettingsPageSkeleton;
